// extracted by mini-css-extract-plugin
export default {"horizontal-expander":"styles__horizontal-expander--iYzdu","horizontal-expander-content":"styles__horizontal-expander-content--WDfDR"};